// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2uTr0","footer":"ModalCreateQualiphyProcedure_footer__2Cy8v","additionData":"ModalCreateQualiphyProcedure_additionData__NKK0I"};